import {NgModule} from '@angular/core'
import {Event, NavigationStart, PreloadAllModules, Router, RouterModule, Routes} from '@angular/router'

// COMMON BASE COMPONENTS
import {LoginComponent} from './shared/components/loginPage/login.component'
import {MainLayoutModule} from './shared/components/main-layout/main-layout.module'
import {AuthService} from './shared/services/auth.service'
import {CacheService} from './shared/services/cache.service'
import {IbransonPreviewModule} from './shared/components/image-editor/ibranson-preview/ibranson-preview.module'
import {IbransonPreviewPageComponent} from './shared/components/image-editor/ibranson-preview/ibranson-preview-page.component'

const routes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'login/:resetId', component: LoginComponent},
  {path: 'preview/ibranson', component: IbransonPreviewPageComponent},
  {path: '**', redirectTo: '/error', pathMatch: 'full'}
]

@NgModule({
  imports: [
    MainLayoutModule,
    IbransonPreviewModule,
    RouterModule.forRoot(routes, {
    // onSameUrlNavigation: 'reload',
    useHash: true,
    preloadingStrategy: PreloadAllModules
}),
  ],
  exports: [
    RouterModule,
  ],
})
export class AppRoutingModule {

  constructor(
    private authService: AuthService,
    private router: Router,
    private SCS: CacheService
  ) {
    /**
     * При переключении маршрута - обновить данные в кеше
     */
    this.router.events.subscribe((evt: Event) => {
      if (evt instanceof NavigationStart) {
        // TODO: Вернуть инициализацию данных обратно
        // this.SCS.checkUpdate();
      }
    })

    /**
     * Проверка авторизации пользователя
     * если пользователь не авторизован - перейти на форму авторизации
     */
    const AUTH = this.authService.checkAuthentication()
    if (!AUTH && !this.router.url.startsWith('/login')) {
      this.router.navigate(['login'])
    // } else {
      // this.Router.navigate(['']);
    }
  }

}
